import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardTask from "./CardTask";
import moment from "moment";
import { fetchMeetings } from "../../services/MeetingService"
import { fetchBotMeetings } from "../../services/UserBotMeetingService"
import { fetchCalendarMeetings } from "../../services/UserCalendarMeetingService"

const Task = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const { uploads } = useSelector((state) => state.uploadsReducer);
  const { meetings, calendarMeetings } = useSelector(
    (state) => state.meetingsReducer
  );
  const [tab, setTab] = useState(1);

  const fetchPastTranscripts = async () => {
    let total = 0;
    let arr = [];
    uploads &&
      uploads?.forEach((upload, idx) => {
        let participant;
        try {
          participant = Object.entries(upload.participants)[0][0];
        } catch (err) {
          // console.log(err);
        }
        if (participant)
          arr.push({
            ...upload,
            idx: idx,
            taskType: "uploads",
            tasks: upload.participants[participant].tasks.map((item) => {
              if (item?.name) return item;
              else
                return {
                  name: item?.name ? item.name : item,
                  completed: item?.completed ? item.completed : false,
                  taskDone: item?.taskDone ? item.taskDone : false,
                  taskDeleted: item?.taskDeleted ? item.taskDeleted : false,
                };
            }),
            participant: participant,
          });
      });
    // console.log("Uploads:", arr);
    meetings &&
      meetings?.forEach((meeting, idx) => {
        if (meeting?.tasks)
          arr.push({
            ...meeting,
            taskType: "botMeetings",
            idx: idx,
          });
      });
    // console.log("Bot Meetings:", arr);
    calendarMeetings &&
      calendarMeetings?.detail !== "Invalid token" &&
      calendarMeetings?.forEach((meet, idx) => {
        if (meet?.tasks)
          arr.push({
            ...meet,
            taskType: "calendarMeetings",
            idx: idx,
          });
      });
    // console.log("Calendar Meetings:", arr);
    arr.sort((a, b) =>
      parseInt(moment(moment(a?.createdAt)?.toDate()).format("YYYYMMDDHHmmss")) -
        parseInt(moment(moment(b?.createdAt)?.toDate()).format("YYYYMMDDHHmmss")) >
      0
        ? -1
        : 1
    );
    // console.log("Fetched tasks:", arr);
    setData(arr);
  };

  useEffect(() => {
    fetchPastTranscripts();
  }, [uploads, meetings, calendarMeetings]);

  useEffect(() => {
    fetchMeetings(dispatch);
    fetchBotMeetings(dispatch);
    fetchCalendarMeetings(dispatch);
  }, []);
  // console.log("Data before rendering:", data);
  return (
    <div className="w-full overflow-x-hidden">
      <div className="3xl:text-3xl text-2xl mb-[20px] font-medium">Tasks</div>
      <div className="text-[18px] my-[10px]">
        Please complete/follow-up on action items below.
      </div>
      <div className="flex gap-[20px] w-fit justify-between items-center mb-[15px]">
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(1);
          }}
          style={{ color: tab === 1 ? "#07457f" : "#384853" }}
        >
          <div className="flex items-center gap-[5px]">My Tasks</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 1 ? "1.2px" : "0px" }}
          ></div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(2);
          }}
          style={{ color: tab === 2 ? "#07457f" : "#384853" }}
        >
          <div>Completed</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 2 ? "1.2px" : "0px" }}
          ></div>
        </div>
      </div>
      {tab === 1 && (
        <>
          {data?.length > 0 ? (
            data.map((taskGroup, index) => {
              return taskGroup.tasks.map((task, idx) => {
                if (!task?.taskDone && !task?.completed && !task?.taskDeleted)
                  return (
                    <CardTask
                      key={idx}
                      group={taskGroup}
                      data={task}
                      idx={idx}
                    />
                  );
                return "";
              });
            })
          ) : (
            <div className="my-[10px] text-gray-500">No tasks</div>
          )}
        </>
      )}
      {tab === 2 && (
        <>
          {data?.length > 0 ? (
            data.map((taskGroup, index) => {
              return taskGroup.tasks.map((task, idx) => {
                if (
                  !task?.taskDone &&
                  !task?.completed &&
                  !task?.taskDeleted &&
                  task?.name !== ""
                )
                  return (
                    <CardTask
                      key={idx}
                      group={taskGroup}
                      data={task}
                      idx={idx}
                      completed
                    />
                  );
                return null;
              });
            })
          ) : (
            <div className="my-[10px] text-gray-500">No tasks</div>
          )}
        </>
      )}
    </div>
  );
};

export default Task;
